import { t } from 'ttag';

const formatMinutes = (minutes?: number): string => {
  if (!minutes && minutes !== 0) return '';

  // `const duration` instead of `const minutes` to reuse existing translations.
  const duration = minutes;

  return minutes === 1 ? t`${duration} minute` : t`${duration} minutes`;
};

const formatHours = (hours?: number): string => {
  if (!hours && hours !== 0) return '';

  return hours === 1 ? t`${hours} hour` : t`${hours} hours`;
};

export const formatDurationInMinutes = (duration?: number): string => {
  if (!duration && duration !== 0) return '';

  const minutes = duration % 60;
  const hours = Math.floor(duration / 60);

  if (hours && minutes) {
    return formatHours(hours) + t` and ` + formatMinutes(minutes);
  } else if (hours) {
    return formatHours(hours);
  } else {
    return formatMinutes(minutes);
  }
};
